import { useState, useEffect} from 'react'

export function useIsMobile(){
    const [ isMobile, setIsMobile ] = useState()
    const [ isOS, setIsOS ] = useState()
    
    //Valida si es desktop o mobile
    useEffect(()=>{
        if(!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            setIsMobile('desktop')
        }
        else{
            setIsMobile('movil')
            if(/Android/i.test(navigator.userAgent)){ setIsOS('Android') }
            else if(/iPhone|iPad|iPod/i.test(navigator.userAgent)){ setIsOS('iOS') }
            else{ setIsOS('Other') }
        }
    },[])

    return{
        isMobile,
        isOS
    }
}